import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { MemberRoleLinkService } from 'src/app/Service/member-role-link/member-role-link.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { ReplectRoleMemberModel, RoleMemberMappedModel } from 'src/app/ViewModel/RoleMemberMappedModel';
import { RoleMemberPostModel } from 'src/app/ViewModel/RoleMemberPostModel';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { ProjectViewModel } from "src/app/ViewModel/ProjectModel";
import { MatDialog } from '@angular/material/dialog';
import { ReplaceMemberComponent } from '../replace-member/replace-member.component';

@Component({
	selector: 'app-member-role-link',
	templateUrl: './member-role-link.component.html',
	styleUrls: ['./member-role-link.component.css']
})
export class MemberRoleLinkComponent implements OnInit {

	rolesList: ReadonlyArray<RoleFeatureModel> = [];
	private businessGroupList: ReadonlyArray<BusinessGroupModel> = [];
	memberList: ReadonlyArray<ProjectMemberModel> = [];
	/** User transactional data. Changes done by user, recorded here */
	private userMappedObject = new Map<string, boolean>();
	/** Copy of userMappedObject data, formmated db data */
	private userMappedObjFromDB = new Map<string, boolean>();

	private userMappedObjFromAssignmentDetailsDB = new Map<string, string>();
	/** Selected Business Group Id */
	private businessGroupId!: number;
	/** Role Header Checkbox */
	private roleHeader: any = {};
	memberHeader: any = {};
	enableFilter = false;
	enableFullscreen = false;
	canUpload: boolean = false;
	projectId!: number;
	groupId!: number;
	memberId!: number;
	projectCode!: string;
	acceptFileTypes: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	@ViewChild('grid') public grid!: GridComponent;
	@ViewChild('excelMemberRoleUpload') excelMemberRoleUpload: any;
	ReplectRoleMemberModel: ReplectRoleMemberModel[];

	public pageSize = [5, 10, 20, {
		text: 'All',
		value: 'all'
	}];

	constructor(
		private mapRoleFeatureService: MapRoleFeatureService,
		private memberRoleLinkService: MemberRoleLinkService,
		private commonService: CommonService,
		private notificationService: NotificationService,
		private loaderService: LoaderService,
		private _commonService: CommonService,
		private _notificationService: NotificationService,
		private dialog: MatDialog
	) {
		this.commonService.selectedProjectId.subscribe(data => {
			if (data) {
				this.getBusinessGroupList(data);
			}
		});
	}

	ngOnInit() {
		this.projectId = this._commonService.getProjectId();
		this.projectCode = this._commonService.getProjectCode();
		this.groupId = this._commonService.getLoggedInUserGroupId();
		this.memberId = this._commonService.getLoggedInUserId();

		this.enableMemberRoleFeatures();
	}


	async callApis() {
		// Get project members list. Kendo row data
		this.memberList = await this.memberRoleLinkService.getMembersList(this.commonService.getProjectId(), this.businessGroupId).toPromise();
		// Get available roles. Kendo column data
		this.rolesList = await this.mapRoleFeatureService.getDedAgainstDe('Role', this.businessGroupId, null, null).toPromise();
		this.getMappedRoleMembers();
	}

	enableMemberRoleFeatures() {
		this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {
			this.canUpload = res.some(data => data.feature_Desc == 'Upload');
		});
	}

	/**
	 * Get business group list
	 * @param projectId 
	 */
	getBusinessGroupList(projectId: number) {
		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data: BusinessGroupModel[]) => {
			this.businessGroupList = data.filter(eachData => eachData.is_Active);
		});
	}

	checkGridHeight() {
		if (this.memberList.length > 0)
			return 540;
		else
			return 182;
	}

	/**
	 * Business group dropdown event handling
	 * @param event 
	 */
	changeBusinessGroup(event: { value: string; }) {
		if (event.value !== '-2') {
			this.businessGroupId = Number(event.value);
			this.userMappedObjFromDB.clear();
			this.callApis();
		} else {
			this.clearValues();
		}
	}

	/**
	 * Get already mapped role-members link
	 */
	getMappedRoleMembers() {
		this.memberRoleLinkService.getMappedRoleMembers(this.commonService.getProjectId(), this.businessGroupId).subscribe(data => {
			this.formatDataDbToUi(data);
		});
	}

	formatDataDbToUi(arrData: RoleMemberMappedModel[]) {
		arrData.forEach(eachData => {
			this.userMappedObjFromDB.set(`${eachData.memberId}_${eachData.roleId}`, eachData.isCheck);
			this.userMappedObjFromAssignmentDetailsDB.set(`${eachData.memberId}_${eachData.roleId}`, eachData.assignmentDetails);
		});
		this.setMemberHeader();
		this.setRoleHeader();
	}

	/**
	 * Returns whether the memberId and roleId mappped or not
	 * @param memberId 
	 * @param roleId 
	 */
	isChecked = (memberId: number, roleId: number) => this.userMappedObjFromDB.get(`${memberId}_${roleId}`);


	GetAssignmentDetails = (memberId: number, roleId: number) => this.userMappedObjFromAssignmentDetailsDB.get(`${memberId}_${roleId}`);

	/**
	 * Kendo row checkbox event handling
	 * Map MemberId and RoleId
	 * @param isChecked 
	 * @param memberId 
	 * @param roleId 
	 */
	mapMemberRole(isChecked: boolean, memberId: number, roleId: number) {
		let key = `${memberId}_${roleId}`;
		if (this.userMappedObject.has(key)) {
			this.userMappedObject.delete(key);
		} else {
			this.userMappedObject.set(key, isChecked);
		}
		this.userMappedObjFromDB.set(key, isChecked);

		this.setMemberHeader(memberId);
		this.setRoleHeader(roleId);
	}

	/**
	 * Save mapped Member Roles
	 */
	submitMapped() {
		// no kendo row data
		if (!this.memberList.length) {
			return;
		}

		let roleMembersMapping = this.formatDataUiToDb();

		if (!roleMembersMapping.length) {
			this.notificationService.showToast("No new changes done", 'Warning');
			return;
		}
		let reqData: RoleMemberPostModel = {
			"roleMembersMapping": roleMembersMapping,
			"groupId": this.businessGroupId,
			"projectId": this.commonService.getProjectId(),
			"createdBy": this.commonService.getLoggedInUserId(),
			"inActiveMemberIds": ''
		}

		this.memberRoleLinkService.CheckRoleMemberWFAssignment(reqData).subscribe(data => {
			if (data.length > 0) {
				this.ReplectRoleMemberModel = data;

				const dialogRef = this.dialog.open(ReplaceMemberComponent, {
					panelClass: ['mat-dialog-secondary', 'w80'],
					data: { RoleMembersUpdated: roleMembersMapping, ReplacementRequiredMembers: this.ReplectRoleMemberModel, IsMemberRemoved: false }
				});
				dialogRef.afterClosed().subscribe((res: any) => {
					if (res.length > 0) {
						let UpdatedReqData: RoleMemberPostModel = {
							"roleMembersMapping": res,
							"groupId": this.businessGroupId,
							"projectId": this.commonService.getProjectId(),
							"createdBy": this.commonService.getLoggedInUserId(),
							"inActiveMemberIds": ''
						}

						this.memberRoleLinkService.mapMemberRoles(UpdatedReqData).subscribe(data => {
							this.notificationService.handleResponse(data);
							this.userMappedObject.clear();
						});
					}
				});
			}
			else {
				this.memberRoleLinkService.mapMemberRoles(reqData).subscribe(data => {
					this.notificationService.handleResponse(data);
					this.userMappedObject.clear();
				});
			}
		})
	}

	/**
	 * Format UI Data (Object) to DB Data (Array). Done before API call
	 */
	formatDataUiToDb() {
		let output: RoleMemberMappedModel[] = [];
		let splitData = [];
		this.userMappedObject.forEach((isCheck, key) => {
			splitData = key.split('_');
			output.push(this.convertData(Number(splitData[0]), Number(splitData[1]), isCheck, this.GetAssignmentDetails(Number(splitData[1]), Number(splitData[0])), 0));
		});
		return output;
	}

	/**
	 * Returns Params as Object
	 * @param memberId 
	 * @param roleId 
	 * @param isCheck 
	 */
	convertData = (memberId: number, roleId: number, isCheck: boolean, assignmentDetails: string, delegateMemberId: number) => ({ memberId, roleId, isCheck, assignmentDetails, delegateMemberId })

	/**
	 * Column Header Checkbox event
	 * Check/UnCheck all members below that column (role)
	 * @param isChecked 
	 * @param roleId 
	 */console
	checkAllMembers(isChecked: boolean, roleId: number) {
		this.memberList.forEach(eachMember => {
			this.userMappedObject.set(`${eachMember.memberId}_${roleId}`, isChecked);
			this.userMappedObjFromDB.set(`${eachMember.memberId}_${roleId}`, isChecked); // update in UI variable also
		});
		this.roleHeader[roleId] = isChecked;
	}

	checkAllRoles(isChecked: boolean, memId: number) {
		this.rolesList.forEach(eachRole => {
			this.userMappedObject.set(`${memId}_${eachRole.dedId}`, isChecked);
			this.userMappedObjFromDB.set(`${memId}_${eachRole.dedId}`, isChecked);
		});
		this.memberHeader[memId] = isChecked;
	}

	/**
	 * Set Feature Header Checkbox Status.
	 * Call after API data received and
	 * Call after every row data checkbox value changes
	 * @param roleId 
	 */
	setRoleHeader(roleId?: number) {
		if (!roleId) {
			if (this.memberList.length) {
				this.rolesList.forEach(role => {
					this.roleHeader[role.dedId] = this.memberList.every((member) => !!this.userMappedObjFromDB.get(member.memberId + '_' + role.dedId));
				});
			}
		} else {
			this.roleHeader[roleId] = this.memberList.every((member) => !!this.userMappedObject.get(member.memberId + '_' + roleId));
		}
	}
	setMemberHeader(memId?: number) {
		if (!memId) {
			this.memberList.forEach(mem => {
				this.memberHeader[mem.memberId] = this.rolesList.every((role) => !!this.userMappedObjFromDB.get(mem.memberId + '_' + role.dedId));
			});
		}
		else {
			this.memberHeader[memId] = this.rolesList.every((role) => !!this.userMappedObject.get(memId + '_' + role.dedId));
		}
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	clearValues() {
		this.memberList = [];
		this.roleHeader = {};
		this.userMappedObject.clear();
		this.userMappedObjFromDB.clear();
	}

	downloadMemberRoleExcelTemplate() {
		this.loaderService.isLoading.next(true);
		let projectModel: ProjectViewModel = this._commonService.getCurrentProjectDetails();
		let fileName = "RoleMember_Excel_Template-" + this._commonService.getProjectCode() + ".xlsx";
		this.memberRoleLinkService.GetMemberRoleExcelTemplate(this.commonService.getProjectId(), this.businessGroupId, 'Role').subscribe((data: any) => {
			this.loaderService.isLoading.next(false);
			const downloadLink = document.createElement("a");
			downloadLink.href = window.URL.createObjectURL(data);
			downloadLink.download = fileName;
			downloadLink.click();
			document.body.removeChild(downloadLink);
		},
			err => {
				this.loaderService.isLoading.next(false);
				this._notificationService.showToast("Error in downloading Template", "Warning");
			});
	}

	uploadMemberRoleExcelTemplate() {
		this.excelMemberRoleUpload.nativeElement.click();
	}

	UploadMemberRoleTemplate(event: any) {
		this.loaderService.isLoading.next(true);
		if (event.target.files[0].type != this.acceptFileTypes) {
			this.loaderService.isLoading.next(false);
			this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
			this.excelMemberRoleUpload.nativeElement.value = '';
			return;
		}

		const formData: FormData = new FormData();
		formData.append('MemberRoleExcelTemplate', event.target.files[0], event.target.files[0].name);
		formData.append('ProjectId', this.projectId.toString());
		formData.append('GroupId', this.businessGroupId.toString());
		formData.append('MemberId', this.memberId.toString());

		this.memberRoleLinkService.UploadMemberRoleExcelTemplate(formData).subscribe((res: any) => {
			this.notificationService.handleResponse(res);
			this.userMappedObject.clear();
			this.callApis();
			this.excelMemberRoleUpload.nativeElement.value = '';
		}, (err) => {
			this.loaderService.isLoading.next(false);
			this.excelMemberRoleUpload.nativeElement.value = '';
			this._notificationService.showToast("Error in upload Template", "Warning");
		});
	}
}
